<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <div v-if="notificationPermissionModal" class="notification-container flex justify-center items-start px-2">
      <div class="bg-white px-4 pb-4 pt-2" style="border-radius: 0px 0px 17px 17px;">
        <p class="material-icons-outlined flex justify-end text-base cursor-pointer" @click="denyNotificationPermission">close</p>
        <div class="flex items-center gap-2">
          <div class="bg-primary w-[70px]">
            <span class="material-symbols-outlined text-white p-2 text-6xl">notifications_active</span>
          </div>
          <div>
            <p class="font-semibold text-lg text-black leading-tight">{{$t('Subscribe to ShipBlu notifications to get the important updates.')}}</p>
            <p class="font-semibold text-sm mt-2 leading-tight text-grey">{{$t('You can disable notifications anytime from your browser.')}}</p>
          </div>
        </div>
        <div class="text-right mt-4">
          <button @click="denyNotificationPermission" class="py-2 mr-4 bg-transparent border-none text-grey-dark px-6 cursor-pointer">{{$t('Later')}}</button>
          <vs-button class="py-2 px-6" @click="requestNotificationPermission">{{$t('Allow')}}</vs-button>
        </div>
      </div>
    </div>
    <div v-if="showNotificationAlert && Object.keys(activeNotification).length > 0" class="notification-container flex justify-center items-start px-2">
      <div class="w-90 bg-white px-4 pb-4 pt-2" style="border-radius: 0px 0px 17px 17px;">
        <p class="material-icons-outlined flex justify-end text-base cursor-pointer" @click="showNotificationAlert = false">close</p>
        <div class="flex items-center gap-2">
          <img src="@/assets/images/logo/logo.png" width="70" alt="">
          <div>
            <p class="font-semibold text-lg text-black leading-tight">{{ activeNotification ? activeNotification.title : '' }}</p>
            <p class="font-semibold text-sm mt-2 leading-tight">{{ activeNotification ? activeNotification.body : '' }}</p>
          </div>
        </div>
        <div class="text-right mt-4">
          <vs-button class="py-2 px-6" @click="showNotificationAlert = false">{{$t('OK!')}}</vs-button>
        </div>
      </div>
    </div>
    <div>
      <div class="flex items-start">
        <Sidebar v-show="selectUserNavItems.length > 0" :navMenuItems="selectUserNavItems" @toggleSidebar="isExpanded = $event" class="flex-shrink-0"></Sidebar>
        <div class="py-[32px] lg:px-[24px] px-[16px] h-[100vh] overflow-auto flex-grow sm:mb-0 mb-[86px]" :style="`${ isExpanded ? 'width: calc(100% - 270px)' : 'width: calc(100% - 82px)'}`" id="scrollContainer">
          <transition :name="routerTransition">
            <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
              <div v-if="routeTitle" class="content-area__heading mr-4" :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                <h2 class="mb-1">{{ $t(routeTitle) }}</h2>
              </div>
              <!-- BREADCRUMB -->
              <vx-breadcrumb class="md:block hidden" :i18nData="i18nData" :store="$store" v-if="$route.meta.breadcrumb" :route="$route" :lang="$i18n.locale" :isRTL="$vs.rtl" />
            </div>
          </transition>

          <transition :name="routerTransition" mode="out-in">
            <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue'
import { growthHacker, sales, finance, customerSupport, admin, opsAdmin, commercialAdmin, teamLeader, manager } from '@/layouts/admin/newNavMenuItems.js'
import themeConfig from '@/../themeConfig.js'
import i18nData from '../../i18n/i18nData.js'
import common from '@/assets/utils/common'
import { sendRequest } from '../../http/axios/requestHelper.js'
import VueJwtDecode from 'vue-jwt-decode'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'

export default {
  components: {
    Sidebar
  },
  data () {
    return {
      growthHacker,
      sales,
      admin,
      finance,
      customerSupport,
      commercialAdmin,
      opsAdmin,
      teamLeader,
      manager,
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle,
      i18nData,
      headOfFleet       : {},
      captain           : {},
      warehouses        : [],
      warehousesDic     : {},
      enableFulfillment : process.env.VUE_APP_ENABLE_FULFILLMENT,
      releaseVersion: process.env.VUE_APP_RELEASE_VERSION,
      showNotificationAlert: false,
      activeNotification: {},
      notificationPermissionModal: false,
      userEmail: '',
      notificationPermission: '',
      userRolesDic: {
        'admin': 'admins',
        'head-of-fleet': 'heads-of-fleet',
        'finance': 'finances',
        'manager': 'managers',
        'customer-support': 'customers-support',
        'growth-hacker': 'growth-hackers',
        'sales': 'sales',
        'ops-admin': 'ops-admins',
        'commercial-admin': 'commercial-admins'
      },
      isExpanded: true,
      updatedTeamLeader: [],
      updatedManager: []
    }
  },
  watch: {
    notificationPermission (val) {
      if (val === 'granted') {
        this.loadUsersData()
      }
    },
    '$route' () {
      this.routeTitle = this.$route.meta.pageTitle
    },
    '$route.name' (val) {
      if (val === 'head-of-fleet-performance' && this.releaseVersion !== 'staging') {
        this.$mixpanel.track('DASH_OPERATIONS_TAB_OPENED', {
          team_leader_name: this.$store.state.AppActiveUser.displayName
        })
      }
    }
  },
  computed: {
    selectUserNavItems () {
      let items = []
      switch (this.$store.state.AppActiveUser.userRole) {
      case 'sales':
        items = this.sales
        break
      case 'growth-hacker':
        items = this.growthHacker
        break
      case 'finance':
        items = this.finance
        break
      case 'customer-support':
        items = this.customerSupport
        break
      case 'commercial-admin':
        items = this.commercialAdmin
        break
      case 'ops-admin':
        items = this.opsAdmin
        break
      case 'admin':
        items = this.admin
        break
      case 'manager':
        items = this.updatedManager
        break
      case 'head-of-fleet':
        items = this.updatedTeamLeader
        break
      }
      return items
    }
  },
  methods: {
    denyNotificationPermission () {
      this.notificationPermissionModal = false
      this.$cookies.set('requestNotification', true, '1w')
    },
    requestNotificationPermission () {
      if (Notification.permission !== 'granted') {
        Notification.requestPermission().then(() => {
          this.notificationPermissionModal = false
        })
      }
    },
    checkNotificationPermission () {
      this.notificationPermissionModal = this.notificationPermission === 'default' && this.$cookies.get('requestNotification') === null
    },
    formatWarehouses (warehouses) {
      this.warehouses = Array.isArray(warehouses) ? warehouses : []
      this.warehousesDic = {}
      this.warehouses.forEach(warehouse => {
        this.warehousesDic[warehouse.id] = {
          name: warehouse.name,
          code: warehouse.code
        }
      })
      switch (this.$store.state.AppActiveUser.userRole) {
      case 'head-of-fleet':
        this.loadHeadOfFleet()
        break
      case 'manager':
        this.loadCaptain()
        break
      case 'finance':
        this.loadFinance()
        break
      default:
        break
      }
    },
    loadHeadOfFleet () {
      sendRequest(false, false, this, `api/v1/users/heads-of-fleet/${this.$store.state.AppActiveUser.uid}/`, 'get', null, true,
        (response) => {
          this.headOfFleet = response.data
          if (this.headOfFleet.primary_warehouse) {
            localStorage.setItem('PrimaryWarehouse', this.warehousesDic[this.headOfFleet.primary_warehouse].code)
            let multiblewarehouses = localStorage.getItem('multipleWarehouses')
            multiblewarehouses = false
            localStorage.setItem('multipleWarehouses', multiblewarehouses)
            const extraItemsIds = [1, 9, 10, 13]
            // The Team Leader is responsible for one warehouse.
            this.updatedTeamLeader = this.teamLeader.map(route => {
              if (route.hasOwnProperty('header') && Array.isArray(route.items)) {
                const updatedItems = route.items.filter(item => !extraItemsIds.includes(item.id)).map(item => {
                  const updatedItem =  { ...item } 
                  if (updatedItem.url && updatedItem.url.includes('warehouseCode')) updatedItem.url = updatedItem.url.replace('warehouseCode', `${this.warehousesDic[this.headOfFleet.primary_warehouse].code}`)
                  if (updatedItem.submenu && Array.isArray(updatedItem.submenu)) {
                    updatedItem.submenu = updatedItem.submenu.map(sub => ({
                      ...sub,
                      url: sub.url.replace('warehouseCode', `${this.warehousesDic[this.headOfFleet.primary_warehouse].code}`)
                    }))
                  }
                  return updatedItem
                })
                return {
                  ...route,
                  header: `${this.warehousesDic[this.headOfFleet.primary_warehouse].name} Warehouse`,
                  i18n: `${this.warehousesDic[this.headOfFleet.primary_warehouse].name} Warehouse`,
                  items: updatedItems
                }
              } else {
                return route
              }
            })
          } else {
            // A Team Leader manages multiple warehouses
            const fixedRoute = [
              {
                url: '/team-leader/search',
                name: 'Search',
                i18n: 'Search',
                icon: 'SearchIcon',
                slug: 'head-of-fleet-search',
                iconLibrary: 'feather'
              },
              {
                url: '/team-leader/notifications',
                name: 'Notifications',
                i18n: 'Notifications',
                slug: 'head-of-fleet-notifications',
                items: [],
                icon: 'BellIcon',
                iconLibrary: 'feather',
                isMobileView: false
              },
              {
                url: '/team-leader/dashboard',
                name: 'Summary',
                i18n: 'Summary',
                icon: 'HomeIcon',
                slug: 'head-of-fleet-dashboard',
                iconLibrary: 'feather',
                isMobileView: false
              }
            ]
            this.warehouses.forEach((warehouse, index) => {
              if (!warehouse.is_virtual) {
                const clonedRoutes = this.teamLeader.map((route) => {
                  if (route.hasOwnProperty('header') && Array.isArray(route.items)) {
                    const updatedItems = route.items.map(item => {
                      const newItem = { ...item }
                      if (typeof newItem.url === 'string' && newItem.url.includes('warehouseCode')) newItem.url = newItem.url.replace('warehouseCode', warehouse.code)
                      if (Array.isArray(newItem.submenu)) {
                        newItem.submenu = newItem.submenu.map(sub => {
                          const newSub = { ...sub }
                          if (typeof newSub.url === 'string' && newSub.url.includes('warehouseCode')) newSub.url = newSub.url.replace('warehouseCode', warehouse.code)
                          return newSub
                        })
                      }
                      return newItem
                    })
                    return {
                      ...route,
                      id: index + 1,
                      code: `${warehouse.code}`,
                      name: `${warehouse.name} Warehouse`,
                      i18n: `${warehouse.name} Warehouse`,
                      header: `${warehouse.name} Warehouse`,
                      submenu: updatedItems
                    }
                  }
                  return null
                }).filter(Boolean) 
                this.updatedTeamLeader.push(...clonedRoutes)
              }
            })
            fixedRoute.forEach((route) => {
              this.updatedTeamLeader.unshift(route)
            })
          }
        }
      )
    },
    loadCaptain () {
      sendRequest(false, false, this, `api/v1/users/managers/${this.$store.state.AppActiveUser.uid}/`, 'get', null, true,
        (response) => {
          this.captain = response.data
          if (this.captain.primary_warehouse) {
            localStorage.setItem('PrimaryWarehouse', this.warehousesDic[this.captain.primary_warehouse].code)
            let multiblewarehouses = localStorage.getItem('multipleWarehouses')
            multiblewarehouses = false
            localStorage.setItem('multipleWarehouses', multiblewarehouses)

            // The Manager is responsible for one warehouse.
            this.updatedManager = this.manager.map(route => {
              if (route.hasOwnProperty('header') && Array.isArray(route.items)) {
                const updatedItems = route.items.map(item => {
                  const updatedItem =  { ...item } 
                  if (updatedItem.url && updatedItem.url.includes('warehouseCode')) updatedItem.url = updatedItem.url.replace('warehouseCode', `${this.warehousesDic[this.captain.primary_warehouse].code}`)
                  if (updatedItem.submenu && Array.isArray(updatedItem.submenu)) {
                    updatedItem.submenu = updatedItem.submenu.map(sub => ({
                      ...sub,
                      url: sub.url.replace('warehouseCode', `${this.warehousesDic[this.captain.primary_warehouse].code}`)
                    }))
                  }
                  return updatedItem
                })
                return {
                  ...route,
                  header: `${this.warehousesDic[this.captain.primary_warehouse].name} Warehouse`,
                  i18n: `${this.warehousesDic[this.captain.primary_warehouse].name} Warehouse`,
                  items: updatedItems
                }
              } else {
                return route
              }
            })
          } else {
            // A Manager manages multiple warehouses
            const fixedRoute = [
              {
                id: 2,
                url: '/warehouse-agent/search',
                name: 'Search',
                i18n: 'Search',
                slug: 'captain-search',
                items: [],
                icon: 'SearchIcon',
                iconLibrary: 'feather'
              },
              {
                id: 1,
                url: '/warehouse-agent/dashboard',
                name: 'Dashboard',
                i18n: 'Dashboard',
                slug: 'captain-dashboard',
                items: [],
                icon: 'HomeIcon',
                iconLibrary: 'feather'
              }
            ]
            this.warehouses.forEach((warehouse, index) => {
              if (!warehouse.is_virtual) {
                const clonedRoutes = this.manager.map((route) => {
                  if (route.hasOwnProperty('header') && Array.isArray(route.items)) {
                    const updatedItems = route.items.map(item => {
                      const newItem = { ...item }
                      if (typeof newItem.url === 'string' && newItem.url.includes('warehouseCode')) newItem.url = newItem.url.replace('warehouseCode', warehouse.code)
                      if (Array.isArray(newItem.submenu)) {
                        newItem.submenu = newItem.submenu.map(sub => {
                          const newSub = { ...sub }
                          if (typeof newSub.url === 'string' && newSub.url.includes('warehouseCode')) newSub.url = newSub.url.replace('warehouseCode', warehouse.code)
                          return newSub
                        })
                      }
                      return newItem
                    })
                    return {
                      ...route,
                      id: index + 1,
                      code: `${warehouse.code}`,
                      name: `${warehouse.name} Warehouse`,
                      i18n: `${warehouse.name} Warehouse`,
                      header: `${warehouse.name} Warehouse`,
                      submenu: updatedItems
                    }
                  }
                  return null
                }).filter(Boolean) 
                this.updatedManager.push(...clonedRoutes)
              }
            })
            fixedRoute.forEach((route) => {
              this.updatedManager.unshift(route)
            })
          }
        }
      )
    },
    loadFinance () {
      const taskListsSubmenu = []
      const khaznaSubmenu = []
      this.warehouses.forEach(warehouse => {
        if (!warehouse.is_virtual) {
          khaznaSubmenu.push({
            url: `/accounting/management/warehouses/${warehouse.code}/khazna`,
            name: `${warehouse.code} Khazna`,
            i18n: `${warehouse.code} Khazna`,
            slug: 'finance-operations-warehouses-khazna'
          })
          taskListsSubmenu.push({
            url: `/accounting/management/warehouses/${warehouse.code}/task-lists`,
            name: `${warehouse.code} Task lists`,
            i18n: `${warehouse.code} Task lists`,
            slug: 'finance-task-lists'
          })
        }
      })

      const userNavItem = this.selectUserNavItems.find(selectUserNavItem => selectUserNavItem.id === 4)
      if (userNavItem) {
        const taskListsItems = userNavItem.items.find(item => item.id === 11)
        if (taskListsItems) taskListsItems.submenu = taskListsSubmenu

        const khaznaItems = userNavItem.items.find(item => item.id === 12)
        if (khaznaItems) khaznaItems.submenu = khaznaSubmenu
      }
    },
    changeRouteTitle (title) {
      this.routeTitle = title
    },
    getUserRole (userInfo) {
      const roles = userInfo && userInfo[`${process.env.VUE_APP_API_URL}/role`]
      return Array.isArray(roles) ? roles[0] : roles || this.$store.state.AppActiveUser.userRole || ''
    },
    sendFirebaseToken (data) {
      sendRequest(false, false, this, 'api/v1/users/device-tokens/', 'post', data, true,
        () => {
        }
      )
    },
    loadUsersData () {
      sendRequest(false, false, this, `api/v1/users/${this.userRolesDic[this.$store.state.AppActiveUser.userRole]}/${this.$store.state.AppActiveUser.uid}/`, 'get', null, true,
        (response) => {
          this.userEmail = response.data.email
          const messaging = getMessaging()
          onMessage(messaging, (payload) => {
            this.showNotificationAlert = true
            this.activeNotification = payload.notification
          })
          getToken(messaging, { vapidKey: process.env.VUE_APP_CLOUD_MESSAGING_ID}).then((currentToken) => {
            if (currentToken) {
              const data = {
                token: currentToken,
                email: this.userEmail
              }
              this.sendFirebaseToken(data)
            }
          })
        }
      )
    }
  },
  created () {
    if (!common.isIOS()) {
      this.notificationPermission = (typeof Notification !== 'undefined') ? Notification.permission : ''
      this.checkNotificationPermission()
    }
    const userInfo = localStorage.getItem('accessToken') ? VueJwtDecode.decode(localStorage.getItem('accessToken')) : {}
    this.$store.dispatch('updateUserInfo', {
      displayName: userInfo.name,
      email: userInfo.email,
      photoURL: userInfo.picture,
      providerId: userInfo && userInfo.sub && userInfo.sub.length > 0 ? userInfo.sub.substr(0, userInfo.sub.indexOf('|')) : '',
      uid: userInfo.sub,
      userRole: this.getUserRole(userInfo)
    })
    this.$acl.change(this.$store.state.AppActiveUser.userRole)
    const query = {
      ...this.$route.query,
      page: Number(this.$route.query.page) > 0 ? this.$route.query.page : 1
    }
    if (this.$route.query && this.$route.query.page < 0) {
      this.$router.push({
        query
      }).catch(() => {})
    }
    if (this.notificationPermission === 'granted') {
      this.loadUsersData()
    }
    localStorage.setItem('multipleWarehouses', true)
    if (this.$store.state.AppActiveUser.userRole === 'manager' || this.$store.state.AppActiveUser.userRole === 'head-of-fleet' || this.$store.state.AppActiveUser.userRole === 'finance') {
      common.manageLoadWarehouses(this.formatWarehouses, this)
    } else if (this.$store.state.AppActiveUser.userRole === 'admin') {
      if (this.enableFulfillment === 'false') {
        this.admin.splice(5, 1)
      }
    }
    if (this.$cookies.get('gotVerifyAlert') === null) {
      this.$cookies.set('gotVerifyAlert', false)
    }
    if (this.$cookies.get('language') === 'en') {
      this.$i18n.locale = 'en'
      this.$vs.rtl = false
    } else {
      this.$i18n.locale = 'ar'
      this.$vs.rtl = true
    }
  }
}

</script>

<style>
iframe[title="Message from company"],
iframe[title="Close message"] {
  display: none !important;
}
#shipblu-chat-launcher,
#shipblu-chat-frame,
#fc_frame {
  display: none;
}
.notification-container {
  position: fixed;
  inset: 0;
  background: rgba(72, 72, 72, 0.64);
  z-index: 9999999;
}
</style>
